import { Component, Input } from '@angular/core';

@Component({
  selector: 'trpx-dubai-genz-card',
  templateUrl: './dubai-genz-card.component.html',
  styleUrls: ['./dubai-genz-card.component.scss']
})
export class DubaiGenzCardComponent {
@Input() disneyCards: any;
@Input() isOrange: boolean = false;

  slideConfig = {
    slidesToShow: 3,
    slidesToScroll: 1,
    infinite: true,
    dots: false,
    arrows: false,
    autoplay: true,
    autoplaySpeed: 2000,
    variableWidth: false,
    responsive: [
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          dots: true,
          variableWidth: false,
        },
      },
    ],
  };
}
